import React from 'react';
import { Sprout, ShoppingBasket, LayoutGrid, CalendarDays, Download, Mail } from 'lucide-react';

// CANONICAL Pro feature list for the CRA app.
// KEEP IN SYNC with /landing/src/app/page.js (Next.js — separate codebase, manual sync required).
// When adding/removing features, update both places plus docs/stripe.md.
export const PRO_FEATURES = [
  { icon: Sprout, label: 'Unlimited seeds & plantings' },
  { icon: ShoppingBasket, label: 'Unlimited harvests & tasks' },
  { icon: LayoutGrid, label: 'Unlimited garden layouts' },
  { icon: CalendarDays, label: 'Personalized planting schedules (PDF)' },
  { icon: Download, label: 'Data export (CSV)' },
  { icon: Mail, label: 'Daily email reminders' },
];

// Shared Pro card used in UpgradeModal (compact) and Pricing page (full).
// compact=true: smaller text, single-column feature list, less padding — for modal use
// compact=false: large price, 2-column grid, more padding — for full-page use
// showHeading: renders a "Pro" label at the top of the card
// cta: slot for the upgrade button or link (caller provides)
const PricingProCard = ({ compact = false, showHeading = false, cta }) => (
  <div className={`border border-[#52A675]/30 rounded-2xl bg-[#52A675]/5 ${compact ? 'p-5' : 'p-8'}`}>
    {showHeading && (
      <h2 className="text-2xl font-bold text-[#2F5233] text-center mb-5">Pro</h2>
    )}

    <div className={`text-center ${compact ? 'mb-5' : 'mb-8'}`}>
      <div className="flex items-baseline gap-0.5 justify-center">
        <span className={`font-bold text-[#2F5233] ${compact ? 'text-2xl' : 'text-5xl'}`}>$40</span>
        <span className={`text-gray-500 ${compact ? 'text-sm' : 'text-lg'}`}>/year</span>
      </div>
      <div className={`text-gray-400 ${compact ? 'text-xs mt-0' : 'text-sm mt-1'}`}>
        {compact ? '$3.33/month' : '$3.33/month, billed annually'}
      </div>
    </div>

    <div className={compact
      ? 'space-y-2.5 mb-5'
      : 'grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-4 mb-8'
    }>
      {PRO_FEATURES.map(({ icon: Icon, label }) => (
        <div key={label} className="flex items-center gap-3 text-sm">
          <Icon size={16} className="text-[#52A675] flex-shrink-0" />
          <span className="font-medium text-[#2F5233]">{label}</span>
        </div>
      ))}
    </div>

    {cta}
  </div>
);

export default PricingProCard;
